import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

document.addEventListener('DOMContentLoaded', () => {

    const swiperRealisations = document.querySelector('.swiper__realisations');

    if (swiperRealisations) {

        new Swiper(swiperRealisations, {

            modules: [Autoplay, Navigation],

            slidesPerView: 1,
            spaceBetween: 25,
            loop: true,
            allowTouchMove: true,
            centeredSlides: true,

            autoplay: {
                delay: 1200,
                disableOnInteraction: false,
            },

            speed: 1200,

            navigation: {
                nextEl: '.swiper__next',
                prevEl: '.swiper__prev',
            },

            breakpoints: {
                768: { slidesPerView: 2 },
                1440: { slidesPerView: 3 },
            },
        });
    }
});